<app-header [forceLightBackground]="true"></app-header>
<div class="delegate-page">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="delegate-page--sidebar-col">
      <app-provider-sidebar></app-provider-sidebar>
    </div>
    <div class="delegate-page--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <div class="delegate-container">
        <app-delegate></app-delegate>
      </div>
    </div>
  </div>
</div>
